import React from "react";

/**
 * Componente de formulário para adicionar novo nome
 */
const UF_OPTIONS = [
  "AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG",
  "PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO",
];

const NomeForm = ({
  showAddModal,
  addLoading,
  novoNome,
  poloOptions,
  abrangencias,
  tipoConsultaOptions,
  mostrarCampoNome,
  mostrarCampoCpfCnpj,
  mostrarCampoOab,
  mostrarCampoDocumentos,
  handleNovoNomeChange,
  handleAbrangenciaChange,
  handleAddNome,
  closeModal,
}) => {
  if (!showAddModal) return null;

  // Função auxiliar para marcar/desmarcar todos
  const handleSetAllAbrangencias = (checked) => {
    // Iterando sobre cada abrangência individualmente para garantir que todas sejam atualizadas corretamente
    abrangencias.forEach(abr => {
      const jaEstaPresente = novoNome.lista_tribunais.includes(abr);
      
      // Se está marcando todos e o item ainda não está na lista, ou
      // se está desmarcando todos e o item está na lista
      if ((checked && !jaEstaPresente) || (!checked && jaEstaPresente)) {
        handleAbrangenciaChange(abr);
      }
    });
  };

  // Helper para verificar se todos os tribunais estão selecionados
  const todosOsTribunaisSelecionados = abrangencias.length > 0 && 
    novoNome.lista_tribunais.length === abrangencias.length;
  
  // Helper para verificar se nenhum tribunal está selecionado
  const nenhumTribunalSelecionado = novoNome.lista_tribunais.length === 0;

  const inputCls = "w-full px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring";

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg mx-4 flex flex-col max-h-[90vh]">
        <div className="flex items-center justify-between p-5 border-b border-border">
          <h3 className="text-base font-semibold text-foreground">Cadastrar Novo Nome</h3>
        </div>

        <form className="flex flex-col flex-1 overflow-hidden" onSubmit={handleAddNome}>
          <div className="flex-1 overflow-y-auto p-5 flex flex-col gap-4">

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-foreground">Tipo de Consulta *</label>
              <select
                name="cod_tipo_consulta"
                value={novoNome.cod_tipo_consulta}
                onChange={handleNovoNomeChange}
                required
                className={inputCls}
              >
                {tipoConsultaOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>

            {novoNome.cod_tipo_consulta === 5 && (
              <div className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
                <span className="mt-0.5 shrink-0">⚠️</span>
                <span><strong>Atenção:</strong> A pesquisa por documento depende da disponibilidade de cada tribunal. Nem todos os tribunais oferecem esse tipo de consulta e, por isso, alguns processos podem não ser localizados.</span>
              </div>
            )}

            {mostrarCampoNome && (
              <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-foreground">
                  {novoNome.cod_tipo_consulta === 3 ? "Assunto *" :
                   novoNome.cod_tipo_consulta === 4 ? "Classe Processual *" :
                   novoNome.cod_tipo_consulta === 5 ? "Nome / Identificação *" : "Nome *"}
                </label>
                <input
                  name="nome"
                  value={novoNome.nome}
                  onChange={handleNovoNomeChange}
                  required
                  className={inputCls}
                />
              </div>
            )}

            {novoNome.cod_tipo_consulta === 5 && (
              <label className="flex items-center gap-2 cursor-pointer text-sm">
                <input
                  type="checkbox"
                  name="multiplos_cnpjs"
                  checked={novoNome.multiplos_cnpjs}
                  onChange={handleNovoNomeChange}
                  className="rounded"
                />
                Múltiplos CNPJs de uma mesma Razão Social
              </label>
            )}

            {mostrarCampoCpfCnpj && (
              <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-foreground">CPF/CNPJ</label>
                <input
                  name="cpf_cnpj"
                  value={novoNome.cpf_cnpj}
                  onChange={handleNovoNomeChange}
                  placeholder="CPF: 000.000.000-00 ou CNPJ: AA.AAA.AAA/AAAA-00"
                  maxLength={18}
                  className={inputCls}
                />
              </div>
            )}

            {mostrarCampoOab && (
              <div className="flex flex-col gap-2">
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-foreground">Número OAB *</label>
                  <input
                    name="oab"
                    value={novoNome.oab}
                    onChange={handleNovoNomeChange}
                    required
                    placeholder="Ex: 123456"
                    className={inputCls}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-foreground">UF da OAB *</label>
                  <select
                    name="oab_uf"
                    value={novoNome.oab_uf}
                    onChange={handleNovoNomeChange}
                    required
                    className={inputCls}
                  >
                    <option value="">Selecione a UF...</option>
                    {UF_OPTIONS.map((uf) => (
                      <option key={uf} value={uf}>{uf}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {mostrarCampoDocumentos && (
              <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-foreground">Documentos (CPF/CNPJ) *</label>
                <textarea
                  name="documentos"
                  value={novoNome.documentos}
                  onChange={handleNovoNomeChange}
                  required
                  rows={3}
                  placeholder="Um CPF ou CNPJ por linha"
                  className={inputCls}
                />
                <span className="text-xs text-muted-foreground">Informe um CPF ou CNPJ por linha</span>
              </div>
            )}

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-foreground">Polo *</label>
              <select name="polo" value={novoNome.polo} onChange={handleNovoNomeChange} required className={inputCls}>
                <option value="">Selecione...</option>
                {poloOptions.map((polo) => (
                  <option key={polo} value={polo}>{polo}</option>
                ))}
              </select>
            </div>

            <div className="flex flex-col gap-2">
              <label className="flex items-center gap-2 cursor-pointer text-sm">
                <input type="checkbox" name="nome_exato" checked={novoNome.nome_exato} onChange={handleNovoNomeChange} className="rounded" />
                Nome Exato
              </label>
              <label className="flex items-center gap-2 cursor-pointer text-sm">
                <input type="checkbox" name="obter_anexos" checked={novoNome.obter_anexos} onChange={handleNovoNomeChange} className="rounded" />
                Obter Anexos
              </label>
              <label className="flex items-center gap-2 cursor-pointer text-sm">
                <input type="checkbox" name="tribunais_especificos" checked={novoNome.tribunais_especificos} onChange={handleNovoNomeChange} className="rounded" />
                Tribunais Específicos
              </label>
            </div>

            {novoNome.tribunais_especificos && (
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-foreground">Lista de Abrangências</label>
                <div className="flex gap-2">
                  <button
                    type="button"
                    className="px-3 py-1 text-xs rounded border border-border hover:bg-slate-50 disabled:opacity-50"
                    onClick={() => handleSetAllAbrangencias(true)}
                    disabled={abrangencias.length === 0 || todosOsTribunaisSelecionados}
                  >Marcar todos</button>
                  <button
                    type="button"
                    className="px-3 py-1 text-xs rounded border border-border hover:bg-slate-50 disabled:opacity-50"
                    onClick={() => handleSetAllAbrangencias(false)}
                    disabled={abrangencias.length === 0 || nenhumTribunalSelecionado}
                  >Desmarcar todos</button>
                  <span className="text-xs text-muted-foreground self-center ml-auto">
                    {novoNome.lista_tribunais.length} de {abrangencias.length} selecionados
                  </span>
                </div>
                <div className="border border-border rounded-md p-3 max-h-[200px] overflow-y-auto flex flex-wrap gap-1">
                  {abrangencias.map((abr, index) => {
                    const prefixoAtual = abr.substring(0, 2);
                    const itemAnterior = index > 0 ? abrangencias[index - 1] : null;
                    const prefixoAnterior = itemAnterior ? itemAnterior.substring(0, 2) : null;
                    const mostrarDivisor = index > 0 && prefixoAtual !== prefixoAnterior;
                    const selecionado = novoNome.lista_tribunais.includes(abr);
                    return (
                      <React.Fragment key={abr}>
                        {mostrarDivisor && <div className="w-full border-t border-border my-1" />}
                        <label className={`flex items-center gap-1 px-2 py-1 rounded text-xs cursor-pointer transition-colors ${
                          selecionado ? "bg-primary/10 text-primary font-medium" : "hover:bg-slate-50"
                        }`}>
                          <input
                            type="checkbox"
                            checked={selecionado}
                            onChange={() => handleAbrangenciaChange(abr)}
                            className="rounded"
                          />
                          {abr}
                        </label>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-end gap-2 p-5 border-t border-border">
            <button
              type="button"
              className="px-4 py-2 text-sm font-medium rounded-md border border-border text-foreground hover:bg-slate-50 transition-colors"
              onClick={closeModal}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors disabled:opacity-60"
              disabled={addLoading}
            >
              {addLoading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NomeForm;
